import React, { useMemo } from 'react';
import { BottomPopupProps } from '@type/productType';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMenuPermission } from '@src/recoil/permission';
import { useRecoilState } from 'recoil';
import { menuScroll } from '@src/recoil/menu';

const BottomPopup = (props: BottomPopupProps) => {
  const { isBottomPopup, onClickClose, type, clickedList, onClickDelete = () => {}, onClickCopy = () => {} } = props;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [menuScrollValue, setMenuScrollValue] = useRecoilState(menuScroll);
  const storeID = searchParams.get('storeID');

  const {
    isNoAuth1,
    isNoAuth2,
    isNoAuth3,
    isNoAuth4,
    isNoAuth5,
    isNoAuth6,
    isNoAuth7,
    isNoAuth8,
    isNoAuth9,
    isNoAuth10,
    isNoAuth11,
  } = useMenuPermission(storeID);

  const { id = 0, title = '', optionGroupID = '' } = clickedList;

  const PopupListElement = useMemo(() => {
    switch (type) {
      case 'category':
        return (
          <ul className="list-more">
            <li>
              <button
                type="button"
                className="link-g"
                disabled={isNoAuth2}
                onClick={() => {
                  setMenuScrollValue({
                    depth1: window.scrollY,
                    depth2: 0,
                  });
                  navigate(`/product/category?storeID=${storeID}&categoryID=${id}`);
                }}
              >
                카테고리 정보 수정
              </button>
            </li>
            <li>
              <button type="button" className="link-g" disabled={isNoAuth1} onClick={onClickDelete}>
                카테고리 삭제
              </button>
            </li>
          </ul>
        );
      case 'menu':
        return (
          <ul className="list-more">
            <li>
              <button
                type="button"
                className="link-g"
                disabled={isNoAuth3}
                onClick={() => {
                  setMenuScrollValue({
                    depth1: menuScrollValue.depth1,
                    depth2: window.scrollY,
                  });
                  navigate(`/product/form?storeID=${storeID}&productID=${id}`);
                }}
              >
                메뉴 정보 수정
              </button>
            </li>
            <li>
              <button
                type="button"
                className="link-g"
                disabled={isNoAuth2}
                onClick={() => {
                  setMenuScrollValue({
                    depth1: menuScrollValue.depth1,
                    depth2: window.scrollY,
                  });
                  navigate(`/product/connect?storeID=${storeID}&productID=${id}`);
                }}
              >
                옵션 연결
              </button>
            </li>
            <li>
              <button
                type="button"
                className="link-g"
                disabled={isNoAuth4}
                onClick={() => {
                  setMenuScrollValue({
                    depth1: menuScrollValue.depth1,
                    depth2: window.scrollY,
                  });
                  navigate(`/product/status?storeID=${storeID}&productID=${id}`);
                }}
              >
                메뉴 노출 · 품절 설정
              </button>
            </li>
            <li>
              <button type="button" className="link-g" disabled={isNoAuth1} onClick={onClickDelete}>
                메뉴 삭제
              </button>
            </li>
          </ul>
        );
      case 'optionGroup':
        return (
          <ul className="list-more">
            <li>
              <button
                type="button"
                className="link-g"
                disabled={isNoAuth5}
                onClick={() => {
                  setMenuScrollValue({
                    depth1: window.scrollY,
                    depth2: 0,
                  });
                  navigate(`/product/option-name?storeID=${storeID}&optionGroupID=${id}`);
                }}
              >
                옵션 그룹명 수정
              </button>
            </li>
            <li>
              <button
                type="button"
                className="link-g"
                disabled={isNoAuth6}
                onClick={() => {
                  setMenuScrollValue({
                    depth1: window.scrollY,
                    depth2: 0,
                  });
                  navigate(`/product/option-status?storeID=${storeID}&optionGroupID=${id}`);
                }}
              >
                옵션그룹 노출 설정
              </button>
            </li>
            <li>
              <button
                type="button"
                className="link-g"
                disabled={isNoAuth7}
                onClick={() => {
                  setMenuScrollValue({
                    depth1: window.scrollY,
                    depth2: 0,
                  });
                  navigate(`/product/option-sort?storeID=${storeID}&optionGroupID=${id}`);
                }}
              >
                옵션 순서 설정
              </button>
            </li>
            <li>
              <button
                type="button"
                className="link-g"
                disabled={isNoAuth8}
                onClick={() => {
                  setMenuScrollValue({
                    depth1: window.scrollY,
                    depth2: 0,
                  });
                  navigate(`/product/option-unconnect?storeID=${storeID}&optionGroupID=${id}`);
                }}
              >
                연결 메뉴 모두 해제
              </button>
            </li>
            <li>
              <button type="button" className="link-g" disabled={isNoAuth9} onClick={onClickCopy}>
                옵션그룹 복사
              </button>
            </li>
            <li>
              <button type="button" className="link-g" disabled={isNoAuth9} onClick={onClickDelete}>
                옵션그룹 삭제
              </button>
            </li>
          </ul>
        );
      case 'option':
        return (
          <ul className="list-more">
            <li>
              <button
                type="button"
                className="link-g"
                disabled={isNoAuth10}
                onClick={() => {
                  setMenuScrollValue({
                    depth1: menuScrollValue.depth1,
                    depth2: window.scrollY,
                  });
                  navigate(`/product/option-name?storeID=${storeID}&optionGroupID=${optionGroupID}&optionID=${id}`);
                }}
              >
                옵션명 및 가격 수정
              </button>
            </li>
            <li>
              <button
                type="button"
                className="link-g"
                disabled={isNoAuth11}
                onClick={() => {
                  setMenuScrollValue({
                    depth1: menuScrollValue.depth1,
                    depth2: window.scrollY,
                  });
                  navigate(`/product/option-status?storeID=${storeID}&optionGroupID=${optionGroupID}&optionID=${id}`);
                }}
              >
                옵션 노출 · 품절 설정
              </button>
            </li>
            <li>
              <button type="button" className="link-g" disabled={isNoAuth9} onClick={onClickDelete}>
                옵션 삭제
              </button>
            </li>
          </ul>
        );
      default:
        return null;
    }
  }, [type, storeID, optionGroupID, id]);

  return (
    <div className={`layer-more ${isBottomPopup ? 'open' : ''}`}>
      <div className="inner-layer">
        <div className="layer-head">
          <strong className="tit-layer">{title}</strong>
          <button type="button" className="ico-close" onClick={() => onClickClose()}>
            닫기
          </button>
        </div>
        <div className="layer-body">{PopupListElement}</div>
      </div>
    </div>
  );
};

export default BottomPopup;
